import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjFileUpload"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M2.08301 3.33333C2.08301 2.8731 2.4561 2.5 2.91634 2.5H7.91634L9.99967 5H17.083C17.5433 5 17.9163 5.37308 17.9163 5.83333V16.6667C17.9163 17.1269 17.5433 17.5 17.083 17.5H2.91634C2.4561 17.5 2.08301 17.1269 2.08301 16.6667V3.33333Z",
  stroke: "#737E99",
  "stroke-width": "1.8",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M12.5 10.8277L10 8.33325L7.5 10.8333",
  stroke: "#737E99",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M10 8.33325V14.1666",
  stroke: "#737E99",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var SJ_File_upload = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_File_upload as default };
